import {
  ChangeDetectorRef,
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import {
  ApiService
} from '../api.service';
import {
  SlickCarouselComponent
} from 'ngx-slick-carousel';
import {
  Router,
  RouterModule
} from '@angular/router';
import {
  GlobalServices
} from '../global.services';
import { UserContactService } from '../services/user-contact.service';
import { Subscription } from 'rxjs';
declare var $;

@Component({
  selector: 'app-plan',
  templateUrl: './plan.component.html',
  styleUrls: ['./plan.component.scss']
})
export class PlanComponent implements OnInit, OnDestroy {

  public showMonthlyPlan: boolean = true; //set month plan
  public showYearPlan: boolean = false; //set year plan
  public getPlanData: Array<any> = [];
  public selectedcard: any = {
    'plan': {
      'ind': '',
      'data': '',
      'currentPlan': ''
    }
  };
  public showAlert: boolean = false;
  public responseMessage: string = "";
  public monthData: any = [];
  public planArray = ['monthly', 'yearly'];
  public currentSelectionType: string = 'monthly';
  private planDetectorSubscription: Subscription;

  slideConfig = {}; //slick config
  @HostListener('window:resize', ['$event']) onResize(event) {
    if (this.globalServices.isBrowser) {
      if (document.getElementsByClassName('carousel')) {
        $('.carousel').slick('resize');
        $('.carousel').slick("setPosition", 0);
      }
    }
  }
  slideConfigs = {};
  @ViewChild('slickModal') slickModal: SlickCarouselComponent;
  constructor(public apiService: ApiService, public router: Router, public globalServices: GlobalServices,
    private userContactService: UserContactService) {
    //slick slider config
    if (this.globalServices.isBrowser) {
      this.slickSlider();
    }
    // If route to plan component came from GLOBAL APP
    this.planDetectorSubscription = this.globalServices.subjectTriggerForPlanPage.subscribe((responseChange: any) => {
      this.globalServices.signupStatus = responseChange;
    })
    // If route to plan component came from DIGITAL APP
    if (this.globalServices.isBrowser) {
      if (localStorage.getItem('thankYouMessage') == 'true') {
        this.globalServices.signupStatus = true;
        localStorage.removeItem('thankYouMessage');
      }
    }
  }

  public slickSlider() {
    this.slideConfig = {
      "slidesToShow": 4,
      "slidesToScroll": 1,
      "infinite": false,
      "responsive": [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 839,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          arrows: true

        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          arrows: true
        },
      },
      ]
    };
  }
  public editData: any;
  ngOnInit(): void {
    if (this.globalServices.isBrowser) {
      if (localStorage.getItem('dataArray')) {
        let selectedcard: any = JSON.parse(localStorage.getItem('dataArray'));
        var object = selectedcard.reduce(
          (obj, item) => Object.assign(obj, item), {});
        delete object.name;
        this.currentSelectionType = object['plan']['data']['planDurationObject']['type'] ? object['plan']['data']['planDurationObject']['type'] : 'monthly';
        this.editData = object;
        this.showPlan(this.currentSelectionType);
      } else {
        this.currentSelectionType = 'yearly';
        this.showPlan(this.currentSelectionType);
      }
      if (this.currentSelectionType == 'monthly') {
        this.showMonthlyPlan = true;
        this.showYearPlan = false;
      } else if (this.currentSelectionType == 'yearly') {
        this.showYearPlan = true;
        this.showMonthlyPlan = false;
      }
      if (localStorage.getItem('inviteToken') && this.globalServices.isLoggedIn) {
        this.inviteTokenPostCall(localStorage.getItem('inviteToken'));
      }
    }
  }


  chnageCard(event, key, i, data, crousel) {
    if (this.globalServices.isBrowser) {
      if (data.isCurrentPlan) {
        this.showAlert = true;
        this.responseMessage = 'You have already purchased this plan!';
        return false;
      }
      if (!event.target.closest('.subscription-box').classList.contains('effect') || crousel == 0) {
        if ((this.selectedcard && this.selectedcard[key])) {
          this.selectedcard[key] = {
            'ind': i,
            'data': data,
            'currentPlan': i
          };
        } else {
          this.selectedcard = {
            ...this.selectedcard,
            [key]: {
              'ind': i,
              'data': data,
              'currentPlan': i
            },
          };
        }
      } else {
        this.selectedcard[key] = {
          ind: "",
          data: "",
          currentPlan: ""
        };
      }
      this.submitPlanAllPlanData();
    }
  }

  //show Plan tabbing
  public customPlanData: any = [];
  public planName: any = ['plan'];
  public response: any = [];
  public showPlanDefault(str): void {
    if (this.globalServices.isBrowser) {
      if ($('#' + str).hasClass('active')) {
        return;
      }
      this.getPlanData = [];
      this.planName = ['plan'];
      if (this.slickModal)
        this.slickModal.unslick();
      if (str == 'monthly') {
        this.currentSelectionType = 'monthly';
        this.showMonthlyPlan = true;
        this.showYearPlan = false;
        localStorage.removeItem('planpayment');
        localStorage.removeItem('dataArray');
      } else {
        this.currentSelectionType = 'yearly';
        this.showYearPlan = true;
        this.showMonthlyPlan = false;
        localStorage.removeItem('planpayment');
        localStorage.removeItem('dataArray');
      }
      setTimeout(() => {
        if (str) {
          this.getPlanData = [];
          this.selectedcard = {};
          let userToken = localStorage.getItem('userToken');
          if (userToken) {
            let data = this.response['data'].filter(function (e) {
              return e.subscriptionType === str;
            });
            let monthdata = this.response['data'].filter(function (e) {
              return e.subscriptionType === 'monthly';
            });
            // this.getPlanData = data[0]['subsPlans'];
            let d = this.getPlanData = data[0]['subsPlans'].filter(function (e) {
              return e['planDurationObject']['price'] == 0 && e['isCurrentPlan'] == 1;
            });
            this.getPlanData = data[0]['subsPlans'].filter(function (e) {
              return e['planDurationObject']['price'] > 0;
            });
            this.customPlanData = this.response['customPlanData'];
            for (let i = 0; i < this.response['customPlanData'].length; i++) {
              let obj = this.response['customPlanData'][i];
              this.planName.push(obj['name'])
              for (let j = 0; j < obj['subsPlans'].length; j++) {
                if (obj['subsPlans'][j]['isCurrentPlan'] == 1) {
                  this.selectedcard = {
                    ...this.selectedcard,
                    [obj['name']]: {
                      'ind': i + 1,
                      data: obj['subsPlans'][j],
                      'currentPlan': j
                    }
                  };
                  break;
                } else {
                  this.selectedcard = {
                    ...this.selectedcard,
                    [obj['name']]: {
                      'ind': '',
                      data: '',
                      'currentPlan': ''
                    }
                  };
                }
              }
            }
            for (let i = 0; i < this.getPlanData.length; i++) {
              if (this.getPlanData[i]['isCurrentPlan'] == 1) {
                this.selectedcard['plan'] = {
                  ind: 0,
                  data: this.getPlanData[i],
                  'currentPlan': i
                };
                break;
              } else {
                this.selectedcard['plan'] = {
                  ind: '',
                  data: '',
                  'currentPlan': ''
                };
              }
            }
            if (this.editData) {
              this.editData['plan'] = {
                ind: '',
                data: '',
                'currentPlan': ''
              };
              this.selectedcard = this.editData
            }
            if (d?.length > 0) {
              this.selectedcard['plan'] = {
                ind: 0, data: d[0], 'currentPlan': 1
              }
            }
            if (monthdata[0]['subsPlans'] && monthdata[0]['subsPlans'].length > 0) {
              this.monthData = [];
              for (let obj of monthdata[0]['subsPlans']) {
                this.monthData.push({
                  'key': obj['name'],
                  'total': obj['planDurationObject']['price'] * 12
                });
              }
            }
          }
        }
      }, 0)

    }
  }

  public showPlan(str): void {
    if (this.globalServices.isBrowser) {
      this.getPlanData = [];
      this.planName = ['plan'];
      if (this.slickModal)
        this.slickModal.unslick();
      if (str) {
        this.getPlanData = [];
        this.selectedcard = {};
        let userToken = localStorage.getItem('userToken');
        if (userToken) {
          let url = 'billingservice/subscription/detail/all';
          let data = {
            token: userToken,
            'slug': 'global',
          };
          this.apiService.postbillData(url, data).subscribe((res) => {
            if (res && res['data'] && res['data']) {
              let response: any = res['data'];
              this.response = res;
              let data = response.filter(function (e) {
                return e.subscriptionType === str;
              });
              let monthdata = response.filter(function (e) {
                return e.subscriptionType === 'monthly';
              });
              // this.getPlanData = data[0]['subsPlans'];
              let d = this.getPlanData = data[0]['subsPlans'].filter(function (e) {
                return e['planDurationObject']['price'] == 0 && e['isCurrentPlan'] == 1;
              });
              this.getPlanData = data[0]['subsPlans'].filter(function (e) {
                return e['planDurationObject']['price'] > 0;
              });
              this.customPlanData = res['customPlanData'];
              for (let i = 0; i < res['customPlanData'].length; i++) {
                let obj = res['customPlanData'][i];
                this.planName.push(obj['name'])
                for (let j = 0; j < obj['subsPlans'].length; j++) {
                  if (obj['subsPlans'][j]['isCurrentPlan'] == 1) {
                    this.selectedcard = {
                      ...this.selectedcard,
                      [obj['name']]: {
                        'ind': i + 1,
                        data: obj['subsPlans'][j],
                        'currentPlan': j
                      }
                    };
                    break;
                  } else {
                    this.selectedcard = {
                      ...this.selectedcard,
                      [obj['name']]: {
                        'ind': '',
                        data: '',
                        'currentPlan': ''
                      }
                    };
                  }
                }
              }
              for (let i = 0; i < this.getPlanData.length; i++) {
                if (this.getPlanData[i]['isCurrentPlan'] == 1) {
                  this.selectedcard['plan'] = {
                    ind: 0,
                    data: this.getPlanData[i],
                    'currentPlan': i
                  };
                  break;
                } else {
                  this.selectedcard['plan'] = {
                    ind: '',
                    data: '',
                    'currentPlan': ''
                  };
                }
              }
              if (this.editData) {
                this.selectedcard = this.editData
              }
              if (d?.length > 0) {
                this.selectedcard['plan'] = {
                  ind: 0, data: d[0], 'currentPlan': 1
                }
              }
              if (monthdata[0]['subsPlans'] && monthdata[0]['subsPlans'].length > 0) {
                this.monthData = [];
                for (let obj of monthdata[0]['subsPlans']) {
                  this.monthData.push({
                    'key': obj['name'],
                    'total': obj['planDurationObject']['price'] * 12
                  });
                }
              }
            }
          }, (error) => {
            throw error('something went wrong!');
          });
        }
      }
    }
  }
  public getdatamonth(month) {
    let year: any = new Date().getFullYear();
    return new Date(year, month, 0).getDate();
  };


  public submitPlanAllPlanData(): void {
    if (this.globalServices.isBrowser) {
      let data = [];
      for (let i = 0; i < this.planName.length; i++) {
        data.push({
          [this.planName[i]]: this.selectedcard[this.planName[i]],
          name: this.planName[i]
        });
      }
      localStorage.setItem('dataArray', JSON.stringify(data));
      if (this.selectedcard['plan']['currentPlan'] !== '') {
        let requireddata = [];
        let finalprice: any;
        for (let i = 0; i < data.length; i++) {
          if (this.planName[i] == 'plan') {
            if (this.currentSelectionType == 'monthly') {
              finalprice = data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['planDurationObject']['price'] - ((data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['planDurationObject']['price'] / 100) * +(data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['shopDiscount'] ? data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['shopDiscount'] : 0));
            } else if (this.currentSelectionType == 'yearly') {
              finalprice = ((data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['planDurationObject']['price'] - ((data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['planDurationObject']['price'] / 100) * +(data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['shopDiscount']))) / 12) * 12
            }
          }
          if ((data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data'] && data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['isCurrentPlan'] == 0) || data[i]?.[Object.keys(data[i])[0]]?.['data']?.['planDurationObject']?.['price'] == '0') {
            requireddata.push({
              price: (data[i] && data[i][Object.keys(data[i])[0]] && data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data'] && data[i] && data[i][Object.keys(data[i])[0]] && data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['planDurationObject'] && data[i][Object.keys(data[i])[0]]['data']['planDurationObject']['price']) ? finalprice : (this.planName[i] == 'Wellness Coach') ? (data[i] && data[i][Object.keys(data[i])[0]] && (data[i][Object.keys(data[i])[0]]['data']['planprice'] - ((data[i][Object.keys(data[i])[0]]['data']['planprice'] / 100) * +((data[i][Object.keys(data[i])[0]]['data']['shopDiscount'] !== '') ? data[i][Object.keys(data[i])[0]]['data']['shopDiscount'] : 0))) * data[i][Object.keys(data[i])[0]]['data']['plandur']) : (data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['planprice'] - ((data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['planprice'] / 100) * +(data[i][Object.keys(data[i])[0]]['data']['shopDiscount'] ? data[i][Object.keys(data[i])[0]]['data']['shopDiscount'] : 0))),
              subscriptionId: (data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data'] && data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['_id']) || '',
              subscriptionName: (data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data'] && data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['name']) || '',
              subscriptionType: (data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data'] && data[i][Object.keys(data[i])[0]]['data']['subscriptionType']) ? (data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data'] && data[i][Object.keys(data[i])[0]]['data']['subscriptionType']) : data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['durtype'] ? data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['durtype'] + 'ly' : this.currentSelectionType,
              planCategoryId: data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['planCategoryId'] ? data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['planCategoryId'] : '',
              activeTriCamp: data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['activeTriCamp'],
              triCapmDurStart: data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['triCapmDurStart'],
              triCapmDurEnd: data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['triCapmDurEnd'],
              isTrial: data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['isTrial'],
              noOfDay: data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['noOfDay'],
              plandur: data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['plandur'] ? data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['plandur'] : 1,
              durtype: data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['durtype'] ? data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['durtype'] : this.currentSelectionType.substr(0, this.currentSelectionType.length - 2),
              isTrialUsed: (data[i] && data[i][Object.keys(data[i])[0]] && data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['isTrialUsed'] == undefined || data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['isTrialUsed'] == null) ? 0 : data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['isTrialUsed'],
              occurtype: data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['occurtype'] ? data[i] && data[i][Object.keys(data[i])[0]] && data[i][Object.keys(data[i])[0]]['data']['occurtype'] : '',
              planUsename: this.planName[i]
            });
          }
        }
        let count = 0;
        if (this.globalServices.isBrowser) {
          for (let i = 0; i < requireddata.length; i++) {
            if (requireddata[i]['price'] == '0' || requireddata[i]['price'] == '' || isNaN(requireddata[i]['price'])) {
              count++;
              this.globalServices.priceCheck = {
                price: requireddata[i]['price'],
                free: 'nonLoginFreeTrial'
              };
              if (count == this.planName.length) {
                this.router.navigate(['/confirmation']);
              } else {
                if (requireddata) {
                  if (this.globalServices.isBrowser) {
                    this.globalServices.priceCheck = {
                      price: requireddata[i]['price'],
                      free: 'nonLoginFreeTrial'
                    };
                    localStorage.setItem('planpayment', JSON.stringify(requireddata));
                    if (i == (requireddata.length - 1)) {
                      this.router.navigate(['payment']);
                    }
                  }
                }
              }
            } else {
              if (requireddata) {
                if (this.globalServices.isBrowser) {
                  this.globalServices.priceCheck = {
                    price: requireddata[i]['price'],
                    free: 'nonLoginFreeTrial'
                  };
                  localStorage.setItem('planpayment', JSON.stringify(requireddata));
                  if (i == (requireddata.length - 1)) {
                    this.router.navigate(['payment']);
                  }

                }
              }
            }
          }
        }
      } else {
        this.showAlert = true;
        this.responseMessage = ' Please choose any plan';
      }
    }
  }
  public submitPlan(selectedPlandata: any, price: any, finalprice: any): void {
    if (this.globalServices.isBrowser) {
      if (price == 0) {
        this.router.navigate(['/']);
      } else {
        let requireddata = {
          price: selectedPlandata['planDurationObject']['price'],
          userSubscriptionIds: selectedPlandata['_id'],
          subscriptionType: this.currentSelectionType,
          planName: selectedPlandata['name'],
          finalPrice: finalprice
        };
        if (requireddata) {
          localStorage.setItem('planpayment', JSON.stringify(requireddata));
          this.router.navigate(['payment']);
        }
      }
    }
  }
  public userDetails: any;
  ngDoCheck() {
    if (this.globalServices.isBrowser) {
      for (let i = 0; i < this.planArray.length; i++) {
        if (!isNaN(this.selectedcard) && ((this.getPlanData[i] && this.getPlanData[i]['subscriptionType']) ? (this.getPlanData[i]['subscriptionType'] == this.planArray[i]) : false)) {
          let setintvl = setInterval(() => {
            let ele: any = document.getElementById('plan-checkbox' + this.selectedcard);
            if (ele) {
              clearInterval(setintvl);
              ele.setAttribute('checked', 'true');
            }
          }, 100);
        }
      }
    }
  }
  public triggerCloseEvent() {
    this.showAlert = false;
  }
  public accordianPlanChange(event, index: number) {
    if (this.globalServices.isBrowser) {
      let els: any = document.getElementsByClassName('subs-wrap');
      if (els) {
        let el: any = document.getElementsByClassName('subs-wrap')[index];

        if (el.getElementsByClassName('subs-content')[0].classList.contains('active')) {
          el.classList.remove("togglearrow");
          el.getElementsByClassName('subs-content')[0].classList.remove("active");
        } else {
          el.classList.add("togglearrow");
          el.getElementsByClassName('subs-content')[0].classList.add("active");
        }
      }
      $('.carousel').slick("setPosition", 0);
    }
  }
  public accordianChange(index: number): void {
    if (this.globalServices.isBrowser) {
      let els: any = document.getElementsByClassName('accordian');
      if (els) {
        let el: any = document.getElementsByClassName('accordian')[index];
        if (el.classList.contains('active')) {
          el.classList.remove("active");
        } else {
          for (let elem of els) {
            elem.classList.remove("active");
          }
          el.classList.add("active");
        }
      }
    }
  }
  getamount(total, price) {
    if (this.globalServices.isBrowser) {
      return (((total - price) * 100) / total).toFixed(2);
    }
  }

  inviteTokenPostCall(inviteTokenFromLocal) {
    if (this.globalServices.isBrowser) {
      if (inviteTokenFromLocal) {
        this.userContactService.postQuestionaireData(inviteTokenFromLocal).subscribe((resOfInviteToken: any) => {
          if (resOfInviteToken) {
            localStorage.removeItem('inviteToken');
          }
        });
      }
    }
  }

  ngOnDestroy() {
    this.planDetectorSubscription.unsubscribe();
  }
}
